
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.833 2.5h8.334c.916 0 1.666.75 1.666 1.667V17.5L10 15l-5.833 2.5V4.167c0-.917.75-1.667 1.666-1.667zM10 13.183L14.167 15V4.167H5.833V15L10 13.183z","fill":"#9AA0B5"}})])
          )
        }
      }
    